import React, { useCallback, useEffect, useState, useRef } from 'react';
const names = ['Cecilia H.', 'Martín G.', 'Laura P.', 'Diego R.', 'Ana M.', 'Carlos S.', 'Lucía F.', 'Pablo T.'];
const cities = ['San Luis', 'Córdoba', 'Rosario', 'Mendoza', 'CABA', 'Tucumán', 'Salta', 'Neuquén'];
const products = ['Pack Completo Sociales + Gestión 360', 'Pack Completo Sociales + Gestión 360', 'Sociales Primaria Lista', 'Sociales Primaria Lista'];
function randomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function PurchaseNotification() {
  const [notification, setNotification] = useState<{
    name: string;
    city: string;
    product: string;
    time: string;
  } | null>(null);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const hideTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const clearAllTimeouts = useCallback(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
  }, []);
  const show = useCallback(() => {
    setNotification({
      name: randomItem(names),
      city: randomItem(cities),
      product: randomItem(products),
      time: String(Math.floor(Math.random() * 15) + 2)
    });
    hideTimeoutRef.current = setTimeout(() => {
      setNotification(null);
      timeoutRef.current = setTimeout(show, Math.floor(Math.random() * 25000) + 25000);
    }, 4000);
  }, []);
  useEffect(() => {
    // Delay first notification significantly to not interfere with initial load
    timeoutRef.current = setTimeout(show, 15000);
    return () => clearAllTimeouts();
  }, [show, clearAllTimeouts]);
  if (!notification) return null;
  return <div className="fixed bottom-4 left-4 z-50 bg-brand-card rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.4)] border border-brand-border p-3 max-w-[260px] pointer-events-none" role="status" aria-live="polite" data-id="element-248">
      <div className="flex items-start gap-3" data-id="element-249">
        <span className="text-brand-accent text-sm mt-0.5" aria-hidden="true" data-id="element-250">
          ✅
        </span>
        <div data-id="element-251">
          <div className="text-[10px] font-bold text-brand-accent uppercase tracking-widest mb-1" data-id="element-252">
            Compra verificada
          </div>
          <div className="text-xs text-white leading-tight mb-0.5" data-id="element-253">
            <span className="font-bold" data-id="element-254">{notification.name}</span> de{' '}
            {notification.city}
          </div>
          <div className="text-[11px] text-white/80 leading-tight mb-1.5" data-id="element-255">
            compró{' '}
            <span className="font-bold text-white" data-id="element-256">{notification.product}</span>{' '}
            🌍
          </div>
          <div className="text-[10px] text-white/70 italic font-medium" data-id="element-257">
            hace {notification.time} minutos
          </div>
        </div>
      </div>
    </div>;
}